import React, { useState, useEffect } from "react";
import ImageA from '../image/C83z2DmMj-2ok.jpg';
import ImageB from '../image//240_F_782734817_pcv8G1yJ5hWwAL0OsFRpZWTylWMFOQtJ.jpg';

const ads = [ImageA, ImageB];

function HomeBgBanner2() {
  const [activeAd, setActiveAd] = useState(0);

  useEffect(() => {
    const rotate = setInterval(() => {
      setActiveAd((prev) => (prev + 1) % ads.length);
    }, 3000);
    return () => clearInterval(rotate);
  }, []);

  return (
    <div className='homebgbanner'>
      <div className="ads-slider-wrapper d-flex justify-content-center align-items-center px-0 mb-4 mt-3">
        <div
          // className="ads-slider-box rounded shadow"
          className="ads-slider-box"
          style={{
            backgroundImage: `url(${ads[activeAd]})`,
          }}
        ></div>
      </div>
    </div>
  );
}

export default HomeBgBanner2;

/* external CSS applied separately */
